import * as Phone                       from 'libphonenumber-js';
import { Fragment }                     from 'react';
import { getVerificationAddressString } from './display_helpers';
import { useAccessToken }               from './google_auth';
import { useVerificationOptions }       from './gmb_api';
import { verificationMethods }          from './gmb_api';
import classNames                       from 'classnames';
import React                            from 'react';
import showVerifyModal                  from './verify_modal';


export default function VerificationOptionsView({
  userName,
  business,
  verificationAddress,
  googleLocation,
  updateGoogleLocation,
  progressStart,
  progressEnd,
  navigateBackTo
}) {
  const { options, optionsStatus } = useVerificationOptions({
    verificationAddress,
    googleLocation,
    progressStart,
    progressEnd
  });

  if (optionsStatus === 'pending')
    return null;

  if (optionsStatus === 'failed')
    return <VerificationOptionsFailed/>;

  if (!options.length)
    return <NoVerificationOptions/>;

  return (
    <Fragment>
      <div className="list media-list block inset">
        <p>To verify your location, Google will send you a verification PIN code using one of the methods below.</p>
      </div>
      <div className="list media-list block inset verification-options">
        <div className="list-group">
          <ul>
            <li className="list-group-title">Choose an option</li>
            {options.map(verifyOption => {
              return (
                <VerifyOption key={verifyOption.verificationMethod} {...{
                  userName,
                  business,
                  googleLocation,
                  updateGoogleLocation,
                  verifyOption,
                  navigateBackTo
                }}/>
              );
            })}
          </ul>
        </div>
      </div>
    </Fragment>
  );
}

function VerifyOption({
  userName,
  business,
  googleLocation,
  updateGoogleLocation,
  verifyOption,
  navigateBackTo
}) {
  const accessToken = useAccessToken();

  function onClick() {
    showVerifyModal({
      accessToken,
      userName,
      business,
      googleLocation,
      updateGoogleLocation,
      verifyOption,
      tabletFullScreen: false,
      navigateBackTo
    });
  }

  const { verificationMethod } = verifyOption;

  const className = classNames([
    'item-content',
    'verify-option',
    `verify-option-${verificationMethod.toLowerCase()}`
  ]);

  return (
    <li className={className} onClick={onClick}>
      <div className="item-inner">
        <div className="item-title">
          <VerificationOptionTitle {...{ verifyOption }}/>
        </div>
        <div className="item-subtitle">
          <VerificationOptionDescription {...{ verifyOption }}/>
        </div>
      </div>
    </li>
  );
}

function VerificationOptionTitle({ verifyOption }) {
  const { verificationMethod } = verifyOption;
  switch (verificationMethod) {
    case verificationMethods.SMS:
      return 'SMS';
    case verificationMethods.PHONE_CALL:
      return 'Phone';
    case verificationMethods.EMAIL:
      return 'Email';
    case verificationMethods.ADDRESS:
      return 'Postal Mail';
    default:
      return null;
  }
}

function VerificationOptionDescription({ verifyOption }) {
  const { verificationMethod } = verifyOption;

  switch (verificationMethod) {

    case verificationMethods.SMS: {
      const { phoneNumber } = verifyOption.phoneData;
      const formattedPhone  = Phone.format(phoneNumber, 'National');
      return `Text me at ${formattedPhone}`;
    }

    case verificationMethods.PHONE_CALL: {
      const { phoneNumber } = verifyOption.phoneData;
      const formattedPhone  = Phone.format(phoneNumber, 'National');
      return `Call me at ${formattedPhone}`;
    }

    case verificationMethods.EMAIL: {
      const { userName }   = verifyOption.emailData;
      const { domainName } = verifyOption.emailData;
      const emailAddress   = `${userName}@${domainName}`;
      return `Email me at ${emailAddress}`;
    }

    case verificationMethods.ADDRESS: {
      const streetAddress = getVerificationAddressString(verifyOption);
      return (
        <Fragment>
          Send a postcard to me at<br/>{streetAddress}
        </Fragment>
      );
    }

    default:
      return null;
  }
}

function VerificationOptionsFailed() {
  return (
    <div className="list media-list block inset no-locations-found">
      <p>There was an error fetching verification options for this location.</p>
    </div>
  );
}

function NoVerificationOptions() {
  return (
    <div className="list media-list block inset no-locations-found">
      <p>There were no verification options returned for this location.</p>
    </div>
  );
}
